export default "__VITE_ASSET__e6b2618c__"